const oneToOne = () => import('@/pages/oneToOne/index.vue');
const lectureList = () => import('@/pages/oneToOne/lectureList.vue');
const serveDetail = () => import('@/pages/oneToOne/serveDetail.vue');
const pdfView = () => import('@/pages/oneToOne/pdfView.vue');


export default [
  {
    path: '/oneToOneHome',
    component: oneToOne,
  },
  {
    path: '/oneToOneLecture',
    component: lectureList,
  },
  {
    path: '/oneToOneServeDetail',
    component: serveDetail,
  },
  {
    path: '/oneToOnePdfView',
    component: pdfView,
  },
];
